import {StrictMode} from 'react';
import ReactDOM from 'react-dom/client';

import { toast } from 'react-toastify';
//import reportWebVitals from './reportWebVitals'

import App from './App';
import AppProviders from './providers/AppProviders';

import "./styles/main.scss";
import 'react-toastify/dist/ReactToastify.css'
import { Demo, ServiceDemo } from './components/alert/alert';

const ToastTester = () => {
  const testAllVariants = () => {
    // Test all basic variants
    toast.success('Success test')
    toast.error('Error test')
    toast.warning('Warning test')
    toast.info('Info test')

    // Test custom variants
    toast('Dark variant', { className: 'Toastify__toast--dark' })
    toast('Gradient variant', { className: 'Toastify__toast--gradient' })

    // Test long content
    toast.info('This is a very long message to test how the toast handles content wrapping and ensures readability across different screen sizes.')

    // Test with custom styling
    toast.success('Custom styled toast', {
      style: {
        background: 'linear-gradient(45deg, #ff6b6b, #ee5a24)',
      }
    })
  }

  return <button onClick={testAllVariants}>Test All Toast Variants</button>
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    {/* <ToastTester /> */}
    <AppProviders>
      <App />
      {/* <Demo />
      <ServiceDemo /> */}
    </AppProviders>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
